module.exports = __webpack_public_path__ + "img/katinaproestakis.cf165265.jpg";